import * as React from 'react';
import { MatchedProperty } from './Container';
import Table from './BottomSectionComponents/Table';
import NoResults from './BottomSectionComponents/NoResults';
import UnvalidatedNotes from './BottomSectionComponents/UnvalidatedNotes';
import Button from '../Button';
import styled from '@emotion/styled';

const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

interface Props {
  matches: Array<MatchedProperty>;
  searchWasMade: boolean;
  matchesLoading: boolean;
  hasMoreMatches: boolean;
  loadingMoreMatches: boolean;
  loadMoreMatches: () => void;
  saveAsUnvalidated: boolean;
  returnToPropertyMatch: () => void;
  handleFileSelect: (files: Array<File>) => void;
  files: Array<File>;
  removeFile: (index: number) => void;
  handleOnSave: (match: MatchedProperty[]) => void;
  saveUnvalidated: () => void;
  validationNote: string;
  handleValidationNoteChange: (e: any) => void;
}

function Results(props: Props) {
  if (props.saveAsUnvalidated) {
    return (
      <UnvalidatedNotes
        handleValidationNoteChange={props.handleValidationNoteChange}
        validationNote={props.validationNote}
        save={props.saveUnvalidated}
        removeFile={props.removeFile}
        files={props.files}
        handleFileSelect={props.handleFileSelect}
        returnToPropertyMatch={props.returnToPropertyMatch}
      />
    );
  }

  if (!props.matchesLoading && props.searchWasMade && props.matches.length > 0) {
    return (
      <React.Fragment>
        <Table handleOnSave={props.handleOnSave} matches={props.matches} />
        {props.hasMoreMatches && (
          <LoadMoreContainer>
            <Button onClick={props.loadMoreMatches} loadingStatus={props.loadingMoreMatches}>
              Load more results
            </Button>
          </LoadMoreContainer>
        )}
      </React.Fragment>
    );
  } else if (!props.matchesLoading && props.searchWasMade && !props.matches.length) {
    return <NoResults save={props.saveUnvalidated} />;
  }

  return null;
}

export default Results;
